import React from 'react';
import BottomSheetModal from './BottomSheetModal';
import './PromptPreviewModal.css';

/**
 * Prompt Preview Modal Component
 * Displays structured JSON and formatted prompt preview
 */
const PromptPreviewModal = ({ 
  isOpen, 
  onClose, 
  selectedPrompt = '',
  selectedStructuredJson = {}
}) => {

  
  return (
    <BottomSheetModal
      isOpen={isOpen}
      onClose={onClose}
      title="LLM Prompt Preview"
      maxHeight="80vh"
      showGripper={true}
    >
      <div className="prompt-preview-modal-content">
        <div className="preview-section">
          <h4 className="preview-section-title">Structured JSON (Sent to Backend)</h4>
          <div className="preview-code-block">
            <pre className="preview-code">
              {JSON.stringify(selectedStructuredJson, null, 2)}
            </pre>
          </div>
        </div>
        
        <div className="preview-section">
          <h4 className="preview-section-title">Formatted Prompt (Sent to LLM)</h4>
          <div className="preview-code-block">
            <pre className="preview-code">
              {selectedPrompt}
            </pre>
          </div>
        </div>
      </div>
    </BottomSheetModal>
  );
};

export default PromptPreviewModal; 